module.exports = __webpack_public_path__ + "img/info-i-alert-icon.c667878b.svg";